<template>
  <page-view>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="搜索条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择" default-value="0">
                  <a-select-option value="1">标题</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="关键字">
                <a-input v-model="queryParam.keywords" placeholder />
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons" :style="{}">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button type="primary" icon="plus" @click="$refs.add.show()">新增评论</a-button>
      </div>

      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
        :scroll="{ x: 1200 }"
      >
        <!-- <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span> -->
        <span slot="username" slot-scope="text">
          <ellipsis :length="30" tooltip>
            {{ text }}
          </ellipsis>
        </span>
        <span slot="status" slot-scope="text">
          <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
        </span>
        <span slot="description" slot-scope="text">
          <ellipsis :length="4" tooltip>{{ text }}</ellipsis>
        </span>
        <span slot="rmb_slot" slot-scope="text">
          <span>{{ text || 0 | currency('￥') }}</span>
        </span>
        <span slot="group" slot-scope="text, record">
          <a-tag v-if="text" :color="record.color">
            {{ text }}
          </a-tag>
          <a-tag v-else>未分组</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="$refs.edit.show(record)">修改</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗？" @confirm="handleDelComment(record)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </s-table>
    </a-card>
    <add-message-model @ok="$refs.table.refresh()" ref="add" />
    <edit-message-model @ok="$refs.table.refresh()" ref="edit" />
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import moment from 'moment'
import { STable, Ellipsis } from '@/components'
import { queryListOfMessage, deleteMessage } from '@/api/pyq'
import AddMessageModel from './modules/AddMessageModel'
import EditMessageModel from './modules/EditMessageModel'
const statusMap = {
  0: {
    status: 'processing',
    text: '待审核'
  },
  1: {
    status: 'success',
    text: '审核通过'
  }
}
export default {
  name: 'DeviceIndex',
  components: {
    PageView,
    STable,
    AddMessageModel,
    EditMessageModel,
    Ellipsis
  },
  data() {
    return {
      mdl: {},

      // 查询参数
      queryParam: {},
      loading: false,
      // 表头
      columns: [
        {
          title: '评论标题',
          dataIndex: 'comment_title',
          width: 150,
          scopedSlots: { customRender: 'comment_title' }
        },
        {
          title: '评论内容',
          dataIndex: 'comment_text',
          width: 300,
          scopedSlots: { customRender: 'comment_text' }
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 120,
          scopedSlots: { customRender: 'create_time' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return queryListOfMessage(Object.assign(parameter, this.queryParam)).then(res => {
          // console.log(res)
          return res
        })
      },
      selectedRowKeys: [],
      selectedRows: []

      // custom table alert & rowSelection
      // options: {
      //   alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
      //   rowSelection: {
      //     selectedRowKeys: this.selectedRowKeys,
      //     onChange: this.onSelectChange
      //   }
      // },
      // optionAlertShow: false
    }
  },
  filters: {
    statusFilter(type) {
      return statusMap[type].text
    },
    statusTypeFilter(type) {
      return statusMap[type].status
    }
  },
  created() {
    this.tableOption()
  },
  methods: {
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: true,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange,
            getCheckboxProps: record => ({
              props: {
                disabled: record.no === 'No 2', // Column
                name: record.no
              }
            })
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    copy(text) {
      this.$copyText(text)
      this.$message.success('复制成功！')
    },
    groupChange() {
      const hide = this.$message.loading('正在更改分组')
      setTimeout(() => {
        hide()
        this.$message.success('修改成功')
        this.$refs.table.refresh()
      }, 3000)
    },
    handleRobot(record) {
      this.$refs.weixinModal.show({ servant_id: record.id })
    },
    handleStatus(record) {
      const hide = this.$message.loading('审核中', 0)
      AgentApi.updateStatus({
        servant_id: record.id,
        status: 1
      })
        .then(res => {
          setTimeout(hide, 0)
          this.$message.success('审核通过')
        })
        .finally(() => {
          this.$refs.table.refresh()
        })
    },
    handleDelComment(record) {
      this.loading = true
      deleteMessage({
        id: record.id
      }).then(res => {
        if (res.code === 1) {
          this.$message.success('删除成功')
          this.$refs.table.refresh()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleEdit(record) {
      this.$refs.editRelationModal.show({ servant_id: record.id, relation_id: record.relation_id })
    },
    handleSub(record) {
      if (record.status !== 0) {
        this.$message.info(`${record.no} 订阅成功`)
      } else {
        this.$message.error(`${record.no} 订阅失败，规则已关闭`)
      }
    },
    handleOk() {
      this.$refs.table.refresh()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    resetSearchForm() {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
